import DOMPurify from "dompurify";
import cn from "classnames";
import { Tabs, Tab } from "@rshbintech.dboul/core-ui";
import commonStyles from "../../../styles.scss";
import { StructuredBlockRow } from "../common/structured-block-row";
import { isTextBlockItemStructured } from "../../utils";
import { TabsBlockProps } from "./types";
import styles from "./styles.scss";

export const TabsBlock = ({ title, tabs }: TabsBlockProps) => (
  <div className={styles.block}>
    {!!title && (
      <h4
        className={styles["block-title"]}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(title),
        }}
      />
    )}
    <div
      className={styles["block-content"]}
      style={{
        marginTop: title ? "48px" : "0",
      }}
    >
      <Tabs>
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            title={tab.title}
            className={styles["block-tab-content"]}
          >
            {isTextBlockItemStructured(tab) ? (
              tab.elements.map((element) => (
                <StructuredBlockRow
                  key={element.id}
                  title={element.title}
                  text={element.text}
                />
              ))
            ) : (
              <p
                className={cn(
                  styles["block-tab-content"],
                  commonStyles["size-medium-long"]
                )}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(tab.text),
                }}
              />
            )}
          </Tab>
        ))}
      </Tabs>
    </div>
  </div>
);
